import cx from 'clsx';

type Props = {
  className?: string;
  wFull?: boolean;
  is3x2?: boolean;
  totalDiscountAmount: number;
};

export function MembershipTotalDiscountAmount({
  className,
  wFull = true,
  is3x2 = false,
  totalDiscountAmount,
}: Props) {
  return (
    <div
      className={cx(
        'flex justify-center flex-wrap gap-[2px] typo-footnote300-semibold text-inverse bg-plusmembership-event-badge rounded-[6px] text-center py-[2px] px-[2px] mt-[2px] break-keep',
        wFull ? 'w-full' : 'w-[140px]',
        is3x2 && '!block',
        className,
      )}
    >
      <div className="flex items-center justify-center gap-4">최대</div>
      <div>{totalDiscountAmount.toLocaleString()}원 할인</div>
    </div>
  );
}
